// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Health.proto" (package "aware", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { LocationMeasurement } from "./Location";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * Health information, similar to what we log from Apple Devices.
 * https://developer.apple.com/documentation/healthkit/hkcategoryvaluesleepanalysis
 *
 * @generated from protobuf enum aware.SleepType
 */
export var SleepType;
(function (SleepType) {
    /**
     * Unspecified
     *
     * @generated from protobuf enum value: ValueSleepAnalysisAsleep = 0;
     */
    SleepType[SleepType["ValueSleepAnalysisAsleep"] = 0] = "ValueSleepAnalysisAsleep";
    /**
     * @generated from protobuf enum value: ValueSleepAnalysisInBed = 1;
     */
    SleepType[SleepType["ValueSleepAnalysisInBed"] = 1] = "ValueSleepAnalysisInBed";
    /**
     * @generated from protobuf enum value: ValueSleepAnalysisAwake = 2;
     */
    SleepType[SleepType["ValueSleepAnalysisAwake"] = 2] = "ValueSleepAnalysisAwake";
    /**
     * @generated from protobuf enum value: ValueSleepAnalysisAsleepCore = 3;
     */
    SleepType[SleepType["ValueSleepAnalysisAsleepCore"] = 3] = "ValueSleepAnalysisAsleepCore";
    /**
     * @generated from protobuf enum value: ValueSleepAnalysisAsleepDeep = 4;
     */
    SleepType[SleepType["ValueSleepAnalysisAsleepDeep"] = 4] = "ValueSleepAnalysisAsleepDeep";
    /**
     * @generated from protobuf enum value: ValueSleepAnalysisAsleepREM = 5;
     */
    SleepType[SleepType["ValueSleepAnalysisAsleepREM"] = 5] = "ValueSleepAnalysisAsleepREM";
})(SleepType || (SleepType = {}));
/**
 * Modeled on Apple's Workout Types.  See https://developer.apple.com/documentation/healthkit/hkworkoutactivitytype for more details.
 * Note that our enum values match Apple's for convenience.  Not all types are yet supported.
 * Unlike the ActivityCategoryType used internally in the Aware Engine, this enum type is not intended to be used as an accessor for any vectors, etc.
 *
 * @generated from protobuf enum aware.WorkoutActivityType
 */
export var WorkoutActivityType;
(function (WorkoutActivityType) {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    WorkoutActivityType[WorkoutActivityType["Unknown"] = 0] = "Unknown";
    /**
     * @generated from protobuf enum value: Climbing = 9;
     */
    WorkoutActivityType[WorkoutActivityType["Climbing"] = 9] = "Climbing";
    /**
     * @generated from protobuf enum value: Dance = 14;
     */
    WorkoutActivityType[WorkoutActivityType["Dance"] = 14] = "Dance";
    /**
     * @generated from protobuf enum value: Hiking = 24;
     */
    WorkoutActivityType[WorkoutActivityType["Hiking"] = 24] = "Hiking";
    /**
     * @generated from protobuf enum value: Rowing = 35;
     */
    WorkoutActivityType[WorkoutActivityType["Rowing"] = 35] = "Rowing";
    /**
     * @generated from protobuf enum value: Running = 37;
     */
    WorkoutActivityType[WorkoutActivityType["Running"] = 37] = "Running";
    /**
     * @generated from protobuf enum value: Sailing = 38;
     */
    WorkoutActivityType[WorkoutActivityType["Sailing"] = 38] = "Sailing";
    /**
     * @generated from protobuf enum value: Walking = 52;
     */
    WorkoutActivityType[WorkoutActivityType["Walking"] = 52] = "Walking";
    /**
     * @generated from protobuf enum value: Yoga = 57;
     */
    WorkoutActivityType[WorkoutActivityType["Yoga"] = 57] = "Yoga";
    /**
     * @generated from protobuf enum value: DownhillSkiing = 61;
     */
    WorkoutActivityType[WorkoutActivityType["DownhillSkiing"] = 61] = "DownhillSkiing";
    /**
     * @generated from protobuf enum value: Pilates = 66;
     */
    WorkoutActivityType[WorkoutActivityType["Pilates"] = 66] = "Pilates";
    /**
     * @generated from protobuf enum value: Snowboarding = 67;
     */
    WorkoutActivityType[WorkoutActivityType["Snowboarding"] = 67] = "Snowboarding";
    /**
     * @generated from protobuf enum value: FitnessGaming = 76;
     */
    WorkoutActivityType[WorkoutActivityType["FitnessGaming"] = 76] = "FitnessGaming";
    /**
     * @generated from protobuf enum value: CardioDance = 77;
     */
    WorkoutActivityType[WorkoutActivityType["CardioDance"] = 77] = "CardioDance";
    /**
     * @generated from protobuf enum value: SocialDance = 78;
     */
    WorkoutActivityType[WorkoutActivityType["SocialDance"] = 78] = "SocialDance";
    /**
     * @generated from protobuf enum value: Other = 3000;
     */
    WorkoutActivityType[WorkoutActivityType["Other"] = 3000] = "Other";
})(WorkoutActivityType || (WorkoutActivityType = {}));
// @generated message type with reflection information, may provide speed optimized methods
class SleepEvent$Type extends MessageType {
    constructor() {
        super("aware.SleepEvent", [
            { no: 1, name: "startDate", kind: "message", T: () => Timestamp },
            { no: 2, name: "endDate", kind: "message", T: () => Timestamp },
            { no: 3, name: "hasUndeterminedDuration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["aware.SleepType", SleepType] },
            { no: 5, name: "metadata", kind: "message", T: () => HealthSampleMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.SleepEvent
 */
export const SleepEvent = new SleepEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SleepEventList$Type extends MessageType {
    constructor() {
        super("aware.SleepEventList", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SleepEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.SleepEventList
 */
export const SleepEventList = new SleepEventList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SleepEventListResponse$Type extends MessageType {
    constructor() {
        super("aware.SleepEventListResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.SleepEventListResponse
 */
export const SleepEventListResponse = new SleepEventListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Workout$Type extends MessageType {
    constructor() {
        super("aware.Workout", [
            { no: 1, name: "startDate", kind: "message", T: () => Timestamp },
            { no: 2, name: "endDate", kind: "message", T: () => Timestamp },
            { no: 3, name: "type", kind: "enum", T: () => ["aware.WorkoutActivityType", WorkoutActivityType] },
            { no: 4, name: "metadata", kind: "message", T: () => HealthSampleMetadata },
            { no: 5, name: "route", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LocationMeasurement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Workout
 */
export const Workout = new Workout$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthSampleMetadata$Type extends MessageType {
    constructor() {
        super("aware.HealthSampleMetadata", [
            { no: 1, name: "sample_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.HealthSampleMetadata
 */
export const HealthSampleMetadata = new HealthSampleMetadata$Type();
/**
 * @generated ServiceType for protobuf service aware.SleepEventListService
 */
export const SleepEventListService = new ServiceType("aware.SleepEventListService", [
    { name: "HandleSleepEventList", options: {}, I: SleepEventList, O: SleepEventListResponse }
]);
